import React from "react";
import { tWithKeyAttr as t } from "../../../../i18nHelper";
import ActionReportBadge from "../ActionReportBadge/ActionReportBadge";
import styles from "../../appointmentsPage.module.css";

/** What the icons on an appointment mean. Shown in the calendar header. */
const IconsLegend: React.FC = () => {
  return (
    <div className={styles.iconsLegend}>
      <span className={styles.iconsLegendItem}>
        <ActionReportBadge
          variant="attended"
          size={12}
          title={t("ATTENDANCE_ATTENDED") || "הגיע"}
        />
      </span>
      <span className={styles.iconsLegendItem}>
        <ActionReportBadge
          variant="saved"
          size={12}
          title={t("APPOINTMENTS_ICON_LEGEND_SAVE") || "שמירת פגישה"}
        />
      </span>
      <span className={styles.iconsLegendItem}>
        <ActionReportBadge
          variant="report"
          size={12}
          title={t("APPOINTMENTS_ICON_LEGEND_REPORT") || "קיים דוח"}
        />
      </span>
    </div>
  );
};

export default IconsLegend;
